module.exports = __webpack_public_path__ + "images/emoji/bird.eab55fe494174905a145.png";